var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-emp-footer',{attrs:{"helpData":_vm.helpData,"copyRightb":_vm.copyRightb,"copyRighta":_vm.copyRighta,"qrCode":_vm.qrCode,"isShowCopyright":_vm.isShowCopyright}})}
var staticRenderFns = []

export { render, staticRenderFns }